/* TLY v3 header behaviour (Agent 3, 2026-10-25). Vanilla, deferred. Enhances server-rendered links only.
   - desktop dropdowns: hover/focus-within open in CSS; this adds aria-expanded sync, Escape, tap-to-open on touch, viewport clamp
   - Rewards: opens the Smile.io panel when SmileUI is loaded, otherwise follows the link
   - phone drawer: open/close, focus trap, Escape, scroll lock, expandable groups */
(function () {
  var root = document.querySelector('[data-t3-header]');
  if (!root) return;
  var nis = Array.prototype.slice.call(root.querySelectorAll('[data-t3-ni]'));
  var lastPointer = 'mouse';
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);

  function isOpen(li) {
    if (li.classList.contains('t3-esc')) return false;
    return li.classList.contains('is-open') || li.matches(':hover') || li.contains(document.activeElement) && li.matches(':focus-within');
  }
  function sync(li) {
    var a = li.querySelector('.t3-nl');
    if (a) a.setAttribute('aria-expanded', isOpen(li) ? 'true' : 'false');
  }
  function clamp(li) {
    var dd = li.querySelector('.t3-dd');
    if (!dd) return;
    dd.style.setProperty('--t3dx', '0px');
    var r = dd.getBoundingClientRect(), vw = document.documentElement.clientWidth, m = 12, dx = 0;
    if (r.left < m) dx = m - r.left;
    else if (r.right > vw - m) dx = vw - m - r.right;
    if (dx) dd.style.setProperty('--t3dx', Math.round(dx) + 'px');
  }
  function closeAll(except) {
    nis.forEach(function (li) { if (li !== except) { li.classList.remove('is-open'); sync(li); } });
  }
  nis.forEach(function (li) {
    var a = li.querySelector('.t3-nl');
    li.addEventListener('pointerenter', function (e) { if (e.pointerType === 'touch') return; li.classList.remove('t3-esc'); clamp(li); sync(li); });
    li.addEventListener('pointerleave', function (e) { if (e.pointerType === 'touch') return; li.classList.remove('t3-esc'); setTimeout(function () { sync(li); }, 0); });
    li.addEventListener('focusin', function () { clamp(li); setTimeout(function () { sync(li); }, 0); });
    li.addEventListener('focusout', function () { setTimeout(function () { li.classList.remove('t3-esc'); sync(li); }, 0); });
    li.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen(li)) {
        li.classList.add('t3-esc'); li.classList.remove('is-open');
        a.focus(); sync(li); e.stopPropagation();
      } else if (e.key === 'ArrowDown' && e.target === a) {
        var first = li.querySelector('.t3-dd a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    a.addEventListener('click', function (e) {
      // touch: first tap opens the panel, second tap follows the link
      if (lastPointer === 'touch' && !li.classList.contains('is-open')) {
        e.preventDefault(); closeAll(li); clamp(li); li.classList.remove('t3-esc'); li.classList.add('is-open'); sync(li);
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-t3-ni]')) closeAll(null);
  });
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { nis.forEach(clamp); closeDrawerIfDesktop(); }, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { nis.forEach(clamp); });
  nis.forEach(clamp);

  // Rewards Program (Steven 10-25 night): menu button opens Smile.io's own panel with its SDK (SmileUI.openPanel / closePanel).
  // The store runs Smile "lite": the full SDK loads on first use (window.loadSmileSdk). The panel is moved under the menu by CSS
  // (tly-v3-header.css, --t3rw-top / --t3rw-right). Click again, Esc or a click outside closes it. If Smile can't load, go to the page.
  var rwBtns = [].slice.call(document.querySelectorAll('[data-t3-rewards]'));
  function rwPanel() { return document.querySelector('.smile-panel-frame-container'); }
  function rwPlace() {
    var de = document.documentElement, bar = root.querySelector('.t3-navwrap .t3-tbf'), top = 12, right = 12;
    if (bar && bar.offsetParent) {
      var r = bar.getBoundingClientRect();
      top = Math.max(12, r.bottom + 6); right = Math.max(12, de.clientWidth - r.right);
    } else {
      // T3H: phones - under the call bar where it is drawn now (it moves up when the sticky header condenses)
      var h = root.querySelector('.t3-callbar');
      if (!h || !h.offsetHeight) h = root.querySelector('.t3-hrow');
      if (h) top = Math.max(12, h.getBoundingClientRect().bottom + 8);
    }
    de.style.setProperty('--t3rw-top', Math.round(top) + 'px');
    de.style.setProperty('--t3rw-right', Math.round(right) + 'px');
  }
  function rwSync() { var o = !!rwPanel(); rwBtns.forEach(function (b) { b.setAttribute('aria-expanded', o ? 'true' : 'false'); }); return o; }
  function rwSdk() {
    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') return Promise.resolve(window.SmileUI);
    var p = typeof window.loadSmileSdk === 'function' ? Promise.resolve(window.loadSmileSdk()) : Promise.resolve();
    return p.then(function () {
      return new Promise(function (res, rej) {
        var n = 0, t = setInterval(function () {
          if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') { clearInterval(t); res(window.SmileUI); }
          else if (++n > 80) { clearInterval(t); rej(new Error('smile')); }
        }, 100);
      });
    });
  }
  function rwClose() { try { if (rwPanel() && window.SmileUI) window.SmileUI.closePanel(); } catch (err) {} setTimeout(rwSync, 50); setTimeout(rwSync, 500); }
  var rwObs = null;
  function rwWatch() {
    var c = document.getElementById('smile-ui-container');
    if (c && !rwObs) { rwObs = new MutationObserver(rwSync); rwObs.observe(c, { childList: true, subtree: true }); }
  }
  function rwOpen() {
    try { closeDrawer(true); } catch (err) {}
    rwPlace();
    rwSdk().then(function (sm) { sm.openPanel(); rwWatch(); setTimeout(rwSync, 400); setTimeout(function () { rwWatch(); rwSync(); }, 1500); })
      .catch(function () { window.location.href = '/pages/ten-lei-yen-rewards'; });
  }
  rwBtns.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); if (rwPanel()) rwClose(); else rwOpen(); });
  });
  if (rwBtns.length) {
    document.addEventListener('click', function (e) { if (rwPanel() && !e.target.closest('.smile-panel-frame-container,[data-t3-rewards]')) rwClose(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && rwPanel()) { rwClose(); if (rwBtns[0].offsetParent) rwBtns[0].focus(); } });
    window.addEventListener('resize', function () { if (rwPanel()) rwPlace(); });
    window.addEventListener('scroll', function () { if (rwPanel()) rwPlace(); }, { passive: true });
    /* T3H hook (WP1) start: sticky header - re-place the Smile panel when the bar condenses/expands */
    document.addEventListener('t3h:change', function () { if (rwPanel()) { rwPlace(); setTimeout(rwPlace, 420); } });
    root.addEventListener('transitionend', function (e) { if (rwPanel() && e.target.closest && e.target.closest('.t3-hrow,.t3-ann,.t3-navwrap')) rwPlace(); });
    /* T3H hook (WP1) end */
    // keep aria-expanded right when Smile's own close button is used (watch Smile's container once it exists)
    rwWatch(); setTimeout(rwWatch, 3000);
  }

  // phone drawer
  /* Steven 10-25 night - menu hover style A: fill enters from the side the mouse comes in on, clears toward the side it leaves.
     Same method as the approved sample: reset with no transition at the entry side, add is-on; set the exit side, remove is-on.
     Mouse only (phones never see gold). Items with a dropdown stay filled while open (CSS aria-expanded) and clear toward the exit side. */
  [].forEach.call(document.querySelectorAll('.t3-navwrap .t3-mgf, .t3-bl__tabs .t3-mgf'), function (a) {
    var li = a.closest('.t3-ni');
    function side(e) { var r = a.getBoundingClientRect(); return e.clientX < r.left + r.width / 2 ? 'left' : 'right'; }
    a.addEventListener('pointerenter', function (e) {
      if (e.pointerType === 'touch') return;
      a.style.transition = 'none'; a.dataset.side = side(e); a.classList.remove('is-on'); void a.offsetWidth;
      a.style.transition = ''; a.classList.add('is-on');
    });
    a.addEventListener('pointerleave', function (e) { if (e.pointerType === 'touch') return; a.dataset.side = side(e); a.classList.remove('is-on'); });
    if (li && li.querySelector('.t3-dd')) li.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') a.dataset.side = side(e); });
  });

  var mroot = document.getElementById('T3Menu');
  var burger = root.querySelector('[data-t3-open]');
  if (!mroot || !burger) return;
  var panel = mroot.querySelector('.t3-mdrawer');
  var mq = window.matchMedia('(max-width: 989px)');
  function focusables() {
    return Array.prototype.slice.call(panel.querySelectorAll('a[href],button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
  }
  function openDrawer() {
    mroot.hidden = false;
    void mroot.offsetWidth;
    mroot.classList.add('is-open');
    document.documentElement.classList.add('t3-lock');
    burger.setAttribute('aria-expanded', 'true');
    var f = focusables(); (mroot.querySelector('.t3-mclose') || f[0] || panel).focus();
  }
  function closeDrawer(skipFocus) {
    if (mroot.hidden) return;
    mroot.classList.remove('is-open');
    document.documentElement.classList.remove('t3-lock');
    burger.setAttribute('aria-expanded', 'false');
    var done = function () { mroot.hidden = true; };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done(); else setTimeout(done, 300);
    if (!skipFocus) burger.focus();
  }
  function closeDrawerIfDesktop() { if (!mq.matches) closeDrawer(true); }
  burger.addEventListener('click', openDrawer);
  mroot.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-t3-close]')) closeDrawer(); });
  mroot.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.stopPropagation(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  Array.prototype.forEach.call(mroot.querySelectorAll('.t3-mbtn'), function (b) {
    b.addEventListener('click', function () {
      var p = document.getElementById(b.getAttribute('aria-controls'));
      var open = b.getAttribute('aria-expanded') === 'true';
      b.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (p) p.hidden = open;
    });
  });

})();


/* STEP 1 (10-26) - language button behaviour. Click/tap toggles, outside click (capture phase, so it also fires when another widget
   stops propagation) / Escape / Tab-out closes, aria-expanded kept in sync, Up/Down/Home/End move between rows. Separate IIFE so the
   header code above (which returns early on pages without the phone drawer) never skips it. */
(function () {
  var root = document.querySelector('[data-t3-header]');
  if (!root) return;
  var comps = [].slice.call(root.querySelectorAll('[data-t3-lang]'));
  if (!comps.length) return;
  function parts(c) { return { btn: c.querySelector('[data-t3-lang-btn]'), panel: c.querySelector('.t3-lang__panel') }; }
  function rows(c) { return [].slice.call(c.querySelectorAll('[data-t3-lang-row]')); }
  function isOpen(c) { var p = parts(c).panel; return !!p && !p.hidden; }
  function place(c) {
    var p = parts(c).panel; if (!p) return;
    p.style.setProperty('--t3lx', '0px');
    var r = p.getBoundingClientRect(), vw = document.documentElement.clientWidth, m = 8, dx = 0;
    if (r.left < m) dx = m - r.left; else if (r.right > vw - m) dx = vw - m - r.right;
    if (dx) p.style.setProperty('--t3lx', Math.round(dx) + 'px');
  }
  function close(c, focusBtn) {
    var o = parts(c); if (!o.panel || o.panel.hidden) return;
    o.panel.hidden = true; o.btn.setAttribute('aria-expanded', 'false');
    if (focusBtn) o.btn.focus();
  }
  function closeAll(except) { comps.forEach(function (c) { if (c !== except) close(c, false); }); }
  function open(c, focusFirst) {
    closeAll(c);
    var o = parts(c); if (!o.panel) return;
    o.panel.hidden = false; o.btn.setAttribute('aria-expanded', 'true'); place(c);
    if (focusFirst) { var r = rows(c); if (r.length) r[0].focus(); }
  }
  comps.forEach(function (c) {
    var o = parts(c); if (!o.btn || !o.panel) return;
    o.btn.addEventListener('click', function (e) { e.preventDefault(); if (isOpen(c)) close(c, false); else open(c, false); });
    c.addEventListener('keydown', function (e) {
      var k = e.key, r = rows(c), i = r.indexOf(document.activeElement);
      if (k === 'Escape' && isOpen(c)) { e.preventDefault(); e.stopPropagation(); close(c, true); return; }
      if (e.target === o.btn && (k === 'ArrowDown' || k === 'ArrowUp')) { e.preventDefault(); open(c, false); if (r.length) (k === 'ArrowDown' ? r[0] : r[r.length - 1]).focus(); return; }
      if (i < 0 || !isOpen(c)) return;
      if (k === 'ArrowDown') { e.preventDefault(); r[(i + 1) % r.length].focus(); }
      else if (k === 'ArrowUp') { e.preventDefault(); if (i === 0) o.btn.focus(); else r[i - 1].focus(); }
      else if (k === 'Home') { e.preventDefault(); r[0].focus(); }
      else if (k === 'End') { e.preventDefault(); r[r.length - 1].focus(); }
    });
    c.addEventListener('focusout', function (e) { var n = e.relatedTarget; if (n && !c.contains(n)) close(c, false); });
  });
  document.addEventListener('click', function (e) {
    comps.forEach(function (c) { if (isOpen(c) && !c.contains(e.target)) close(c, false); });
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') comps.forEach(function (c) { if (isOpen(c)) close(c, true); });
  });
  var rz; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { comps.forEach(function (c) { if (isOpen(c)) { if (!c.offsetParent) close(c, false); else place(c); } }); }, 100); });
})();

/* ==== T3H (WP1) start ==== */
/* Sticky header "condense on scroll": adds html.t3h, html.t3h-cond (condensed), html.t3h-search (search dropdown open), html.t3h-noanim.
   The section wrapper (.t3h-wrap) is sticky. Condensing is done in CSS with transforms only, so the header's layout box never changes
   size: page content never moves and no layout shift is recorded.
   --t3h-cond = condensed header height (scroll-padding). Scroll path: one passive listener + one rAF, reads scrollY only. */
(function () {
  var root = document.querySelector('[data-t3-header]');
  if (!root || !window.matchMedia || !window.requestAnimationFrame) return;
  if (window.Shopify && window.Shopify.designMode) return;
  var wrap = root.parentElement;
  if (!wrap || !wrap.classList.contains('shopify-section')) return;
  var de = document.documentElement, DOWN = 60, UP = 20;
  var cond = false, ticking = false, naT = 0, rzT = 0, lastW = window.innerWidth;
  var sbtn = root.querySelector('[data-t3-sbtn]'), srow = root.querySelector('[data-t3-srow]');
  var sinput = srow ? srow.querySelector('input[type="search"],input[name="q"]') : null;
  de.classList.add('t3h');
  wrap.classList.add('t3h-wrap');

  function px(n) { return (Math.round(n * 100) / 100) + 'px'; }
  // visible bottom of the condensed header (menu bar on desktop, call bar on phones; transforms + folded announcement included) by a synchronous toggle
  // (no paint in between, transitions off, event not fired). Skipped while the header is hidden (gate not passed yet).
  function visBottom() {
    var els = [root.querySelector('.t3-navwrap'), root.querySelector('.t3-callbar'), root.querySelector('.t3-hrow')];
    for (var i = 0; i < els.length; i++) if (els[i] && els[i].offsetHeight) return els[i].getBoundingClientRect().bottom;
    return root.getBoundingClientRect().bottom;
  }
  function measure() {
    if (!root.offsetHeight) return;
    var had = de.classList.contains('t3h-noanim'), ann = root.querySelector('.t3-ann'), c;
    de.style.setProperty('--t3h-a', px(ann ? ann.offsetHeight : 0)); // the announcement folds away when condensed
    de.classList.add('t3h-noanim');
    if (!cond) de.classList.add('t3h-cond');
    c = visBottom() - root.getBoundingClientRect().top;
    if (!cond) de.classList.remove('t3h-cond');
    if (c > 0) de.style.setProperty('--t3h-cond', px(c));
    void root.offsetHeight; // settle styles in the final state before transitions come back
    if (!had) de.classList.remove('t3h-noanim');
  }
  function openSearch() {
    if (!sbtn || !srow) return;
    // top of the page: the search bar row is already open under the menu, so Search just puts the cursor in it (HDR-B2, Steven 10-27)
    if (!cond) { if (sinput) sinput.focus(); return; }
    de.classList.add('t3h-search');
    sbtn.setAttribute('aria-expanded', 'true');
    if (sinput) { try { sinput.focus({ preventScroll: true }); } catch (err) { sinput.focus(); } }
  }
  function closeSearch(refocus) {
    if (!de.classList.contains('t3h-search')) return;
    de.classList.remove('t3h-search');
    if (sbtn) {
      sbtn.setAttribute('aria-expanded', 'false');
      if (refocus) sbtn.focus();
    }
  }
  function set(c, quiet) {
    if (c === cond) return;
    cond = c;
    de.classList.toggle('t3h-cond', c);
    if (!c) closeSearch(false);
    if (quiet) return;
    try { document.dispatchEvent(new CustomEvent('t3h:change', { detail: { cond: c } })); } catch (err) {}
  }
  function update() {
    ticking = false;
    var y = window.pageYOffset || 0;
    if (!cond && y > DOWN) set(true);
    else if (cond && y < UP) set(false);
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  // start / bfcache / load: land in the right state with no animation (a reload mid-page starts condensed)
  function init() {
    clearTimeout(naT);
    de.classList.add('t3h-noanim');
    var y = window.pageYOffset || 0;
    set(cond ? !(y < UP) : y > DOWN, true);
    measure();
    if (document.readyState === 'complete') {
      requestAnimationFrame(function () { requestAnimationFrame(function () { de.classList.remove('t3h-noanim'); }); });
    }
  }
  init();
  window.addEventListener('load', init);
  window.addEventListener('pageshow', function (e) { if (e.persisted) init(); });
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    clearTimeout(rzT);
    rzT = setTimeout(function () {
      if (window.innerWidth === lastW) return; // mobile browser bars only change the height
      lastW = window.innerWidth;
      closeSearch(false);
      measure();
      update();
    }, 150);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
  // header box resized (gate reveal, announcement wrap, font swap): re-measure the condensed height
  if (window.ResizeObserver) new ResizeObserver(function () { measure(); }).observe(root);
  if (sbtn && srow) {
    sbtn.addEventListener('click', function () { if (de.classList.contains('t3h-search')) closeSearch(true); else openSearch(); });
    document.addEventListener('click', function (e) {
      if (de.classList.contains('t3h-search') && !(e.target.closest && e.target.closest('[data-t3-srow],[data-t3-sbtn]'))) closeSearch(false);
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && de.classList.contains('t3h-search')) closeSearch(true);
    });
  }
})();
/* ==== T3H (WP1) end ==== */

/* ==== HDR-B2 logo (Steven 10-27) start ==== desktop (990px+): the logo's left edge lines up with the "Shop" text in the menu below.
   The menu items share the width and centre their text, so where "Shop" starts depends on the menu; this measures it and sets
   --t3-logo-x (the logo's left margin, tly-v3-header.css HDR-B2) on load, font swap and resize. Phones/tablets: not set. */
(function () {
  var row = document.querySelector('.tly-v3 .t3-hrow'), shop = document.querySelector('.tly-v3 .t3-navwrap .t3-mgf');
  if (!row || !shop) return;
  var t = 0;
  function textLeft(el) {
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null), n, r = document.createRange();
    while ((n = w.nextNode())) { if (/\S/.test(n.nodeValue)) { r.selectNodeContents(n); var b = r.getBoundingClientRect(); if (b.width) return b.left; } }
    return null;
  }
  function place() {
    if (window.innerWidth < 990 || !shop.offsetParent) { row.style.removeProperty('--t3-logo-x'); return; }
    var x = textLeft(shop); if (x === null) return;
    var base = row.getBoundingClientRect().left + parseFloat(getComputedStyle(row).paddingLeft || 0);
    row.style.setProperty('--t3-logo-x', Math.max(0, Math.round((x - base) * 100) / 100) + 'px');
  }
  place();
  window.addEventListener('load', place);
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(place, 100); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(place);
})();
/* ==== HDR-B2 logo end ==== */
